import { PublicQuery, PublicMutation } from './public';

const mocks = {
  Query: () => ({ ...PublicQuery }),
  Mutation: () => ({ ...PublicMutation })
};

export default mocks;
